module.exports = __webpack_public_path__ + "static/media/painManagementImage3@3x.ef986219.png";